export const SupportRoutes = {
  LIST: "/settings/support-tickets",
  DETAIL: "/settings/support-tickets/:id",
} as const;
